import React from 'react';
import { Link } from 'react-router-dom';
import useSEO from '../../hooks/useSEO';
import '../../styles/Catalogo.css';

const CatalogoNaoEncontrado = () => {
  useSEO({
    title: 'Página não encontrada | ABRALIBER',
    description: 'O conteúdo procurado não existe ou foi removido. Veja todos os cursos online gratuitos da ABRALIBER.',
    url: null,
    robots: 'noindex, follow',
  });

  return (
    <main className="seo-page seo-nao-encontrado">
      <h1>Página não encontrada</h1>
      <p>O curso ou a categoria que você procura não existe ou foi removido.</p>
      <p><Link to="/cursos">Ver todos os cursos gratuitos</Link></p>
    </main>
  );
};

export default CatalogoNaoEncontrado;
